import { ILLGenericKeys } from './ll-generic-keys.model';
import { Esig } from './esig.model';
import { ICompanyDetail } from './company-detail.model';
import { IContactDetail } from './contact-detail.model';
import { ILLBusinessCategory } from '.';

export class LCRData {

    majorRevision: number;
    minorRevision: number;
    lcrRevisionId: number;
    lcrId: number;
    splTitle: string;
    splVersion: number;
    splServiceType: ILLGenericKeys;
    signature: Esig;
    setId: string;
    ndcLabelerCode: string;
    effectiveTime: Date;
    busCategory: ILLBusinessCategory;
    modifiedByUser: string;
    modifiedByDate: Date;
    company: ICompanyDetail;
    contact: IContactDetail;
}

